import { render, staticRenderFns } from "./GenericDetailView.vue?vue&type=template&id=19909482&scoped=true"
import script from "./GenericDetailView.vue?vue&type=script&lang=js"
export * from "./GenericDetailView.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./GenericDetailView.vue?vue&type=style&index=1&id=19909482&prod&scoped=true&lang=css"
import style2 from "./GenericDetailView.vue?vue&type=style&index=2&id=19909482&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19909482",
  null
  
)

export default component.exports